export default "__VITE_ASSET__16SguLle__"